import { z } from "@/zod";
import { ulid } from "./commonFields";

export const permission = z.object({
  code: z.string(),
  id: ulid,
  name: z.string(),
});

export const readPermission = permission.readonly();
